<template>
   <div v-if="params.link" class="flex items-center">
      <ExternalLink :link="params.link" />
   </div>
</template>

<script lang="ts" setup>
import type { GridCellProps, RowLinkCellParams } from '~/composables/grid/cell-params'

defineProps<GridCellProps<RowLinkCellParams>>()
</script>
